import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { LoadingButton } from '@mui/lab';
import { Stack, TextField } from '@mui/material';
import api from '../../../api';
import { useDispatch } from 'react-redux';
import { loadingStartAction, loadingStopAction } from '../../../redux/actions/loadingActions';
import { useParams } from 'react-router-dom';

export default function UserWalletHistoryData({ data }) {
  const [walletType, setWalletType] = useState('');
  const [amount, setAmount] = useState('');
  let userId = useParams();

  const dispatch = useDispatch();

  const updateWallet = async () => {
    let reqBody = {
      points: amount,
      transaction_type: walletType,
      transaction_note: walletType + ' by admin',
      user_id: userId?.id,
      isAdmin: true
    };

    let endpoint = 'wallet/create';

    dispatch(loadingStartAction());
    await api.post(endpoint, reqBody);

    window.location.reload()
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label="spanning table">
        <TableBody>
          <TableRow>
            <TableCell>Wallet balance</TableCell>
            <TableCell align="right">{data?.wallet_balance}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell>
              <LoadingButton
                style={{ marginRight: 10 }}
                size="small"
                type="submit"
                variant="contained"
                color="success"
                onClick={() => setWalletType(walletType ? '' : 'credit')}
              >
                + Add Points
              </LoadingButton>
            </TableCell>
            <TableCell align="right">
              <LoadingButton
                size="small"
                type="submit"
                variant="contained"
                color="error"
                onClick={() => setWalletType(walletType ? '' : 'debit')}
              >
                - Withdrawal Points
              </LoadingButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {walletType && (
        <Stack padding={1} spacing={3}>
          <TextField name="amount" label="Enter Amount" value={amount} onChange={(e) => setAmount(e.target.value)} />

          <LoadingButton
            color={walletType === 'credit' ? 'success' : 'error'}
            size="large"
            type="submit"
            variant="contained"
            onClick={updateWallet}
          >
            {walletType === 'credit' ? 'Add Points' : 'Withdrawal Points'}
          </LoadingButton>
        </Stack>
      )}
    </TableContainer>
  );
}
